import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NavService } from '../providers/nav.service';
// import { Cookie } from 'ng2-cookies/ng2-cookies';
import { ApiService } from '../providers/api.service';
import { ToastrService } from 'ngx-toastr';
// import { AuthService, FacebookLoginProvider, SocialUser } from 'angularx-social-login';
// import { CommonService } from '../providers/common.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { platformList, sportList } from '../shared.service';
import { CommonService } from '../providers/common.service';

// import facebookLogin from 'facebook-login';
// const api = facebookLogin({ appId: '325973485413885' });
// declare var $: any;

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.css']
})
export class SigninComponent implements OnInit {
  @ViewChild('myForgotForm', { static: false }) myForgotForm;
  @ViewChild('myContactForm', { static: false }) myContactForm;
  @ViewChild('closeContactUsModal', { static: false }) closeContactUsModal: ElementRef;
  @ViewChild('basicModal', { static: true }) basicModal;
  center:boolean = false;
  signinForm: FormGroup;
  forgotForm: FormGroup;
  contactusForm: FormGroup;
  account: any = {};
  forgotemail = '';
  contactDet: any = {};
  submitted = false;
  submittedForgot = false;
  submittedContact = false;
  loggedIn: boolean;
  showModal = false;
  openModal = false;
  contactDisplay = 'none';
  constructor(
    private formBuilder: FormBuilder,
    private navService: NavService,
    private api: ApiService,
    private toastr: ToastrService,
    private SpinnerService: NgxSpinnerService,
    // private authService: AuthService,
    // private commonService: CommonService,
    private route: Router,
    private commonService: CommonService,
  ) {
    const userDet = localStorage.getItem('userDetails');
    if (userDet) {
      this.route.navigate(['/DashBoard']);
    }
  }

  ngOnInit() {
    this.signinForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required]
    });

    this.forgotForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]]
    });

    this.contactusForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      subject: ['', Validators.required],
      message: ['', Validators.required]
    });
  }

  get f() {
    return this.signinForm.controls;
  }

  get f2() {
    return this.forgotForm.controls;
  }

  get f3() {
    return this.contactusForm.controls;
  }

  onSignIn() {
    this.submitted = true;
    if (this.signinForm.valid) {
      this.SpinnerService.show();
      this.account.device_token = '-';
      this.account.device_type = '3';
      this.account.device_id = '-';

      this.api.authenticate(this.account).subscribe(data => {
        this.SpinnerService.hide();
        if (data && data.code == '100') {
          data.isLogin = true;

          const tempData = data.data.userDetails;
          let platform, sport;
          if (tempData.default_platform_id == platformList.DraftKings) {
            platform = platformList[platformList.DraftKings];
          } else if (tempData.default_platform_id == platformList.FanDuel) {
            platform = platformList[platformList.FanDuel];
          }

          if (tempData.default_sport_id == sportList.NFL) {
            sport = sportList[sportList.NFL];
          } else if (tempData.default_sport_id == sportList.NBA) {
            sport = sportList[sportList.NBA];
          } else if (tempData.default_sport_id == sportList.MLB) {
            sport = sportList[sportList.MLB];
          }

          const Loginuserdetails: any = {
            userDetails: data.data.userDetails,
            isLogin: true,
            isSocialLogin: false,
            user_id: data.user_id,
            accessToken: data.accessToken,
            platformName: platform,
            sportName: sport,
            managePlayerCount: data.data.managePlayerCount
          };

          this.commonService.platformandsport.sport_id = tempData.default_sport_id;
          this.commonService.platformandsport.platform_id = tempData.default_platform_id;

          localStorage.setItem('userDetails', JSON.stringify(Loginuserdetails));
          localStorage.setItem('PackageDetails', JSON.stringify(data.data.packageList));
          localStorage.setItem('userSubscriptionList', JSON.stringify(data.data.userSubscriptionList));

          this.navService.changeNav('item');
          this.toastr.success(data.message, 'Success');
        } else {
          this.toastr.warning(data.message, 'Warning');
        }
      }, (err) => {
        this.SpinnerService.hide();
        this.toastr.error('something went wrong', 'Error');
      });
    }
  }




  onSignUp() {
    this.route.navigate(['/SignUp']);
  }



  onForgotPopup() {
    this.forgotemail = '';
    this.myForgotForm.resetForm();
    this.submittedForgot = false;
  }

  onForgotSubmit() {
    this.submittedForgot = true;
    if (this.forgotForm.valid) {
      const emailDet = {
        email: this.forgotemail
      };
      this.SpinnerService.show();
      this.api.forgotPassword(emailDet).subscribe(data => {
        this.SpinnerService.hide();
        if (data && data.code == 100) {
          this.submittedForgot = false;
          this.forgotemail = '';
          this.toastr.success(data.message, 'Success');
        } else {
          this.toastr.warning(data.message, 'Warning');
        }
      }, (err) => {
        this.SpinnerService.hide();
        this.toastr.error('Somthing Went wrong', 'Error');
      });
    } else {
      // console.log('forgot form invalid');
    }
  }

  onContactPopupInLogin() {
    this.contactDet = {};
    this.myContactForm.resetForm();
    this.submittedContact = false;
    this.contactDisplay = 'block';
  }

  onContactUsSubmit() {
    this.submittedContact = true;
    if (this.contactusForm.valid) {
      // console.log('contact us form valid' + this.contactDet);
      this.SpinnerService.show();
      this.api.contactUs(this.contactDet).subscribe(data => {
        this.SpinnerService.hide();
        this.contactDisplay = 'none';
        if (data && data.code == 100) {
          this.submittedContact = false;
          this.contactDet = {};
          this.toastr.success(data.message, 'Success');
        } else {
          this.toastr.warning(data.message, 'Warning');
        }
      }, (err) => {
        this.SpinnerService.hide();
        this.contactDisplay = 'none';
        this.toastr.error('Somthing Went wrong', 'Error');
      });
    } else {
      // console.log('contact us form invalid');
    }
  }

  onSkip() {
    const data = {
      isLogin: false,
      isSkip: true,
      platformName: platformList[platformList.DraftKings],
      sportName: sportList[sportList.NFL],
      default_platform_id: platformList.DraftKings,
      default_sport_id: sportList.NFL
    };
    this.commonService.platformandsport.sport_id = sportList.NFL;
    this.commonService.platformandsport.platform_id = platformList.DraftKings;
    localStorage.setItem('userDetails', JSON.stringify(data));
    this.navService.changeNav('item');
  }

  closeModalDialog() {
    this.contactDisplay = 'none';
  }

}
